import {Command, CommandMeta, DeriveJSONSchema, SimpleSchema} from "mobx-graphlink";
import {EngineConfig} from "../DB/engineConfigs/@EngineConfig";
import {StatView} from "../DB/statViews/@StatView.js";

const MTClass = StatView;
type MT = typeof MTClass.prototype;

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		entry: DeriveJSONSchema(MTClass, {}),
	}),
	responseSchema: ()=>SimpleSchema({id: {$ref: "UUID"}}),
})
export class AddStatView extends Command<{entry: MT}, {id: string}> {}

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		$id: {$ref: "UUID"},
		$updates: DeriveJSONSchema(MTClass, {excludeKeys: ["id", "creator", "createdAt"], makeOptional_all: true}),
	}),
})
export class UpdateStatView extends Command<{id: string, updates?: Partial<MT>, newData?: MT}> {}

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		id: {$ref: "UUID"},
	}),
})
export class DeleteStatView extends Command<{id: string}, {}> {}